import type {
  SetupIntentResponse,
  OnboardingStatusResponse,
  OnboardingInitiateResponse,
  PaymentMethodResponse,
  AccountSessionResponse,
  DisconnectCheckResponse,
  DisconnectAccountResponse,
} from '@@/types/api';
import { useApi } from './use-api';

export function useStripeApi() {
  const { get, post, del } = useApi('/api/v1/events/stripe');

  return {
    createSetupIntent: () => post<SetupIntentResponse>('/setup-intent'),
    getOnboardingUrl: () => post<OnboardingInitiateResponse>('/onboarding'),
    getOnboardingStatus: () =>
      get<OnboardingStatusResponse>('/onboarding/status'),
    listPaymentMethods: () =>
      get<{ data: PaymentMethodResponse[] }>('/payment-methods'),
    deletePaymentMethod: (id: string) =>
      del<undefined>(`/payment-methods/${id}`),
    createAccountSession: () =>
      post<AccountSessionResponse>('/account-session'),
    getDisconnectBlockers: () =>
      get<DisconnectCheckResponse>('/account/disconnect-check'),
    disconnectAccount: () => del<DisconnectAccountResponse>('/account'),
  };
}
